//------------------------------------------------------------------------------
// メニュー
//------------------------------------------------------------------------------
import { useSelector } from 'react-redux';
import menuConfig from '@/config/menu';

/**
 * メニュー項目一覧作成
 */
export default function menuItems() {

  // 権限一覧 (権限IDと権限種別のマップ)
  const perms = useSelector((state) => state.auth.userPerms);

  // メニュー項目を権限でフィルタリング
  const root = menuConfig.root
      .filter((item) => {
        const permType = perms[item.id];
        return Boolean(permType);
      });

  // ホームボタン追加
  const home = menuConfig.home;
  if (home?.link) {
    root.add(
        home.id, home.label,
        home.link, home.icon);
  }

  // 項目一覧を返す
  return root.children();
}
